import React from "react";
import ReactDOM from "react-dom";

function GiftModal({
  handleModalClose,
  handleModalInputChange,
  handleModalFormSubmit,
  modalContent,
  locales,
}) {
  return ReactDOM.createPortal(
    <div className="gift-checkbox-wrapper">
      <div className="gift-modal active" id="test-modal">
        <button
          onClick={handleModalClose}
          type="button"
          className="close"
          value="Close gift note modal"
          aria-label="Close Button for Gift Note Modal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <h1>{locales.gift_modal_heading.replace(/&#39;/g, "'")}</h1>
        <p>{locales.gift_modal_content.replace(/&#39;/g, "'")}</p>
        <form onSubmit={handleModalFormSubmit}>
          <div className="gift-message-wrapper">
            <label htmlFor="gift-to" className="visually-hidden">
              To:
            </label>
            <input
              type="text"
              className="gift-to"
              id="gift-to"
              value={modalContent.to}
              name="to"
              onChange={handleModalInputChange}
              placeholder={locales.gift_modal_to_placeholder}
            />
            <label htmlFor="gift-from" className="visually-hidden">
              From:
            </label>
            <input
              type="text"
              className="gift-from"
              id="gift-from"
              value={modalContent.from}
              name="from"
              onChange={handleModalInputChange}
              placeholder={locales.gift_modal_from_placeholder}
            />
            <label htmlFor="gift-message" className="visually-hidden">
              Gift Message:
            </label>
            <textarea
              className="gift-message"
              id="gift-message"
              name="message"
              value={modalContent.message}
              onChange={handleModalInputChange}
              placeholder={locales.gift_modal_notes_placeholder.replace(/&#39;/g, "'")}
            >
              Hello
            </textarea>
          </div>
          <div className="error-text">Error: Please fill out the above information.</div>
          <div className="actions">
            <button type="button" onClick={handleModalClose} className="cancel">
              Nevermind
            </button>
            <button type="submit" className="confirm">
              Add Note
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.getElementById("gift-note-modal-root")
  );
}

export default GiftModal;
